'use client';

import { AppFooter } from '@/components/app-footer';
import { AppHeader } from '@/components/app-header';

export default function MarketingLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-background via-background to-muted/40">
      <AppHeader />
      <main className="flex-1">
        <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6">{children}</div>
      </main>
      <AppFooter />
    </div>
  );
}
